import { render } from "./BroodmareTable.vue?vue&type=template&id=2e3cad80"
import script from "./BroodmareTable.vue?vue&type=script&lang=js"
export * from "./BroodmareTable.vue?vue&type=script&lang=js"

import "./BroodmareTable.vue?vue&type=style&index=0&id=2e3cad80&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__